var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "parameter-options-list" }, [
    _c(
      "div",
      { staticClass: "parameter-options-list__header" },
      [
        _c("span", { staticClass: "parameter-options-list__title" }, [
          _vm._v("Opciones")
        ]),
        !_vm.readonly
          ? _c("feather-icon", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Agregar opción",
                  expression: "'Agregar opción'"
                }
              ],
              attrs: { size: "18", icon: "PlusCircleIcon", color: "green" },
              on: { click: _vm.addOption }
            })
          : _vm._e()
      ],
      1
    ),
    _c("table", { staticClass: "parameter-options-list__table" }, [
      _c("thead", [
        _c("tr", [
          _c("th", { staticClass: "parameter-options-list__th" }, [
            _vm._v("Valor")
          ]),
          _c("th", { staticClass: "parameter-options-list__th" }, [
            _vm._v("Descripción")
          ]),
          !_vm.readonly
            ? _c("th", {
                staticClass:
                  "parameter-options-list__th parameter-options-list__th--action"
              })
            : _vm._e()
        ])
      ]),
      _c(
        "tbody",
        _vm._l(_vm.localOptions, function(option, index) {
          return _c(
            "tr",
            {
              key: "option-" + index,
              staticClass: "parameter-options-list__row"
            },
            [
              _c("td", { staticClass: "parameter-options-list__cell" }, [
                !_vm.readonly
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: option.value,
                          expression: "option.value"
                        }
                      ],
                      staticClass: "form-control form-control-sm",
                      attrs: { placeholder: "Valor" },
                      domProps: { value: option.value },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(option, "value", $event.target.value)
                          },
                          _vm.emitUpdate
                        ]
                      }
                    })
                  : _c(
                      "span",
                      { staticClass: "parameter-options-list__text" },
                      [_vm._v(_vm._s(option.value))]
                    )
              ]),
              _c("td", { staticClass: "parameter-options-list__cell" }, [
                !_vm.readonly
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: option.name,
                          expression: "option.name"
                        }
                      ],
                      staticClass: "form-control form-control-sm",
                      attrs: { placeholder: "Descripción" },
                      domProps: { value: option.name },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(option, "name", $event.target.value)
                          },
                          _vm.emitUpdate
                        ]
                      }
                    })
                  : _c(
                      "span",
                      { staticClass: "parameter-options-list__text" },
                      [_vm._v(_vm._s(option.name))]
                    )
              ]),
              !_vm.readonly
                ? _c(
                    "td",
                    {
                      staticClass:
                        "parameter-options-list__cell parameter-options-list__cell--action"
                    },
                    [
                      _c("feather-icon", {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Eliminar opción",
                            expression: "'Eliminar opción'"
                          }
                        ],
                        attrs: {
                          size: "16",
                          icon: "XCircleIcon",
                          color: "red"
                        },
                        on: {
                          click: function($event) {
                            return _vm.deleteOption(index)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }